import React, {Fragment} from 'react';
import {update} from '../../actions/update';
import {addElement} from '../../actions/addElement';
import {updateElement} from '../../actions/updateElement';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";

function List({id, elements, prepend, append, type, update, addElement, updateElement}) {

    const array = [];
    for (const key in elements) {
        array.push(elements[key]);
    }
    array.sort((a, b) => a.position - b.position);

    return (
        <Fragment>
            <div className="form-group">
                <label>{type}</label><br/><label>{"Prepend"}</label>
                <input type="text" className="form-control" value={prepend}
                       onChange={(event) => update(event.target.value, id, "prepend")}/>
            </div>
            <div className="form-group">
                <label>Elementos</label>
                <button type="button" className="btn btn-info ml-4 px-3" onClick={()=>addElement(id)}>+</button>
                {array.map(
                    element => <input key={element.key} type="text" className="form-control"
                                      value={element.content}
                                      onChange={(event) => updateElement(event.target.value, element.key, id)}/>)}
            </div>
            <div className="form-group">
                <label>{"Append"}</label>
                <input type="text" className="form-control" value={append}
                       onChange={(event) => update(event.target.value, id, "append")}/>
            </div>
        </Fragment>
    );
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({update, addElement, updateElement}, dispatch);
}

export default connect(null, mapDispatchToProps)(List);


// WEBPACK FOOTER //
// ./src/admin/components/editor/containers/sections/List.js